// extracted by mini-css-extract-plugin
module.exports = {"fixedNav":"Header_fixedNav__2D10-","offsetNav":"Header_offsetNav__1L7aB","offsetNavHeight":"Header_offsetNavHeight__1uNGF","bottomMargin":"Header_bottomMargin__ugnZD"};